function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8.25,
  cy: 8,
  r: 7,
  stroke: "#FFE600",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.25 1C7.58333 2.16667 5.25 4 5.25 8.5C5.25 13 7.25 14 8.25 15",
  stroke: "#FFE600"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.25 1C8.91667 2.16667 11.25 4 11.25 8.5C11.25 13 9.25 14 8.25 15",
  stroke: "#FFE600"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.25327 6C1.05589 6 9.83552 6 14.25 6",
  stroke: "#FFE600"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.25327 10C1.05589 10 9.83552 10 14.25 10",
  stroke: "#FFE600"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white",
  transform: "translate(0.25)"
})));

function SvgIcon16Globe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon16Globe);
export default __webpack_public_path__ + "static/media/icon-16-globe.d95d17e8.svg";
export { ForwardRef as ReactComponent };